// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div.dx-error-message {\n  white-space: pre-wrap;\n}", "",{"version":3,"sources":["webpack://./src/app/admin/users/users.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF","sourcesContent":["div.dx-error-message {\r\n  white-space: pre-wrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
